<template>
  <div class="smaller-container-wrapper full-height">
    <MobialisFormWithValidation
      @onValidate="submit"
      novalidate
      v-av-analytics-form-submit="{ elementText: $t('message.common.continue') }"
    >
      <p>{{ getVehicleName }}</p>
      <h2 class="mb-3 mb-sm-4 mt-2" v-html-safe="$t('message.eCommerceV2.tradeInFlow.tradeInBalance.heading')"></h2>
      <div class="row form-row pb-2 pt-2">
        <div class="col-sm-6" v-for="(option, index) in tradeInAmountOwingOptions" :key="index">
          <MobialisFancyRadio
            rules="required"
            :textArray="[option]"
            name="tradeInOptions"
            v-model="hasOutstandingTradeInBalance"
            :data-cy="option.value"
          ></MobialisFancyRadio>
        </div>
      </div>
      <p class="text-danger small my-0" v-if="!hasOutstandingTradeInBalance && !isValid">
        {{ $t('message.eCommerceV2.pleaseSelect') }}
      </p>
      <div v-if="hasOutstandingTradeInBalance === this.enums.YesNo.YES" class="row form-row mt-3">
        <div class="col-sm-6">
          <mobialis-text-input-with-validation
            rules="required"
            :label="$t('message.eCommerceV2.tradeInFlow.tradeInBalance.currentBalance')"
            v-model="outstandingTradeInBalance"
            vid="outstandingTradeInBalance"
            :mask-type="languageCode === 'fr-CA' ? 'frenchInt' : 'moneyInt'"
            inputmode="numeric"
            pattern="[0-9]*"
            data-cy="outstandingTradeInBalance"
          >
          </mobialis-text-input-with-validation>
        </div>
      </div>
      <div class="push-down-desktop">
        <mobialis-button type="submit" class="mt-5 mb-3" data-cy="continue">{{
          $t('message.common.continue')
        }}</mobialis-button>
      </div>
    </MobialisFormWithValidation>
  </div>
</template>

<script>
import cloneDeep from 'lodash/fp/cloneDeep';
import { mapGetters, mapState } from 'vuex';
import { enumMixin } from '@/mixins';
import log from '@/services/log';

export default {
  name: 'TradeInAmountOwingForm',
  mixins: [enumMixin],
  data() {
    return {
      tradeInAmountOwingOptions: this.$t('message.eCommerceV2.tradeInFlow.tradeInBalance.options'),
      hasOutstandingTradeInBalance: cloneDeep(this.$store.state.paymentCalculator.hasOutstandingTradeInBalance),
      outstandingTradeInBalance: cloneDeep(this.$store.state.paymentCalculator.outstandingTradeInBalance),
      isValid: true,
    };
  },
  computed: {
    ...mapGetters({
      getVehicleName: 'trade/getVehicleName',
      languageCode: 'user/getLanguageCodeForNumericalInternationalization',
    }),
    ...mapState('trade', ['tradein']),
  },
  methods: {
    async submit(isValid) {
      if (!isValid) {
        this.isValid = false;
        return;
      }
      this.isValid = true;
      this.$store.commit('paymentCalculator/SET_STATE', [
        'hasOutstandingTradeInBalance',
        this.hasOutstandingTradeInBalance,
      ]);
      this.$store.commit('paymentCalculator/SET_STATE', [
        'outstandingTradeInBalance',
        this.hasOutstandingTradeInBalance === this.enums.YesNo.YES ? this.outstandingTradeInBalance : null,
      ]);

      try {
        this.$store.commit('SET_LOADING', true);
        await this.$store.dispatch('trade/getReport');
        // Remove all data associated with the trade in for use in the UI if vehicle is out of range
        // Keep what is attached to the lead state.updateLeadVehicles.tradein
        // for tracking and data collection purposes
        if (this.tradein.tradeVehicleOutOfRange === true) {
          this.$store.commit('paymentCalculator/REMOVE_TRADE');
          this.$store.commit('trade/RESET_VEHICLE');
        }
        this.$router.push({ path: this.getNextRoutePath() });
      } catch (e) {
        log('Error in ecomv2 trade/getReport', e);
        // Remove the vehicle since we can't get the report
        this.$store.commit('trade/RESET_VEHICLE');
        this.$store.commit('paymentCalculator/REMOVE_TRADE');
        this.$router.push({ path: this.getNextRoutePath() });
      } finally {
        this.$store.commit('SET_LOADING', false);
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
